module.exports = __webpack_public_path__ + "img/djgj_banner.d132e72a.png";